export default "__VITE_ASSET__0utkgynL__"